// Firebase initialization (Analytics-only for the BrainPet landing page).
// All config comes from REACT_APP_* env vars — never hard-coded.

import { initializeApp, getApps, getApp } from "firebase/app";
import {
  getAnalytics,
  isSupported,
  logEvent as fbLogEvent,
} from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Singleton Firebase app
function getFirebaseApp() {
  if (!firebaseConfig.apiKey) return null;
  return getApps().length ? getApp() : initializeApp(firebaseConfig);
}

// Analytics is browser-only and requires support (no SSR / no incognito with blocking)
let analyticsPromise = null;
function getAnalyticsInstance() {
  if (typeof window === "undefined") return Promise.resolve(null);
  if (analyticsPromise) return analyticsPromise;
  analyticsPromise = isSupported()
    .then((supported) => {
      const app = getFirebaseApp();
      if (!supported || !app) return null;
      try {
        return getAnalytics(app);
      } catch {
        return null;
      }
    })
    .catch(() => null);
  return analyticsPromise;
}

// Fire-and-forget analytics event. Safe to call before init has resolved.
export function logEvent(name, params = {}) {
  getAnalyticsInstance().then((analytics) => {
    if (!analytics) return;
    try {
      fbLogEvent(analytics, name, params);
    } catch {
      /* swallow — never let analytics break the UI */
    }
  });
}

// Track a page_view (Firebase Analytics fires one automatically on init,
// but we re-fire on route changes for SPA navigation).
export function logPageView(path) {
  logEvent("page_view", {
    page_path: path || (typeof window !== "undefined" ? window.location.pathname : "/"),
    page_location: typeof window !== "undefined" ? window.location.href : undefined,
    page_title: typeof document !== "undefined" ? document.title : undefined,
  });
}

// Eagerly initialize on import so the first page_view auto-fires.
getAnalyticsInstance();
